var render = function render(){var _vm=this,_c=_vm._self._c;return _c('f7-page',{attrs:{"name":"usersManagement"}},[_c('f7-navbar',{staticClass:"navbar--specific"},[_c('f7-nav-left',[_c('h3',[_vm._v("Create User")])]),_vm._v(" "),_c('f7-nav-right',[_c('f7-link',{attrs:{"back":"","icon-material":"navigate_before","icon-size":"30","icon-color":"primary"}})],1)],1),_vm._v(" "),_c('UserForm')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }